// #564 T7 (Björn 26.10.2026): bisher ausgeblendete Einsätze dieses Eigentümers ab einem Datum gesammelt im
// Eigentümerportal sichtbar machen. Erst Vorschau (Anzahl), dann Freigabe. Rechtlich sensible Tickets bleiben immer
// ausgeblendet; es geht keine E-Mail raus. Auswahl wie im Portal: RPC portal_aeltere_einsaetze_freigeben.
import React, { useState } from 'react';
import { CalendarBlank, Eye, MagnifyingGlass } from '@phosphor-icons/react';
import { supabase } from '../../../../../lib/supabase/client';
import { ImmoButton, InnenKarte, KartenTitel, TextFeld, ToastPill, useToastPill } from '../../../../../components/immobilien/ui';

const GLAS: React.CSSProperties = { background: 'var(--glass)' };
const vorEinemJahr = () => { const d = new Date(); d.setFullYear(d.getFullYear() - 1); return d.toISOString().slice(0, 10); };

export function AeltereEinsaetzeKarte({ eigentuemerId }: { eigentuemerId: string }) {
  const [ab, setAb] = useState(vorEinemJahr());
  const [anzahl, setAnzahl] = useState<number | null>(null);
  const [laeuft, setLaeuft] = useState(false);
  const [toast, zeige] = useToastPill();

  const rufe = async (nurZaehlen: boolean) => {
    setLaeuft(true);
    try {
      const { data, error } = await supabase.rpc('portal_aeltere_einsaetze_freigeben', { p_eig: eigentuemerId, p_ab: ab, p_nur_zaehlen: nurZaehlen });
      if (error) throw error;
      const n = Number(data) || 0;
      if (nurZaehlen) setAnzahl(n);
      else { setAnzahl(0); zeige(n === 1 ? '1 Einsatz ist jetzt im Portal sichtbar' : `${n} Einsätze sind jetzt im Portal sichtbar`); }
    } catch (e) {
      zeige(`Nicht möglich: ${e instanceof Error ? e.message : 'Unbekannter Fehler'}`, true);
    } finally { setLaeuft(false); }
  };

  return (
    <InnenKarte style={GLAS}>
      <KartenTitel>Ältere Einsätze im Portal zeigen</KartenTitel>
      <div className="flex items-end flex-wrap" style={{ gap: 8 }}>
        <div style={{ flex: '1 1 200px' }}>
          <TextFeld label="Einsätze ab" type="date" icon={CalendarBlank} wert={ab}
            onChange={(v) => { setAb(v); setAnzahl(null); }} />
        </div>
        <ImmoButton groesse={48} icon={MagnifyingGlass} disabled={laeuft || !ab} onClick={() => { void rufe(true); }}
          title="Zählen, wie viele bisher ausgeblendete Einsätze sichtbar würden">Prüfen</ImmoButton>
        <ImmoButton art="akzent" groesse={48} icon={Eye} disabled={laeuft || !anzahl} onClick={() => { void rufe(false); }}
          title="Diese Einsätze im Eigentümerportal sichtbar machen">{anzahl ? `${anzahl} freigeben` : 'Freigeben'}</ImmoButton>
      </div>
      <span style={{ fontSize: 12, lineHeight: 1.45, color: 'var(--ink3)' }}>
        {anzahl === null ? 'Erst „Prüfen“: zeigt, wie viele bisher ausgeblendete Einsätze dieses Eigentümers seit dem Datum sichtbar würden. '
          : anzahl === 0 ? 'Keine ausgeblendeten Einsätze seit diesem Datum. '
          : `${anzahl === 1 ? '1 Einsatz wird' : `${anzahl} Einsätze werden`} im Portal sichtbar. `}
        Rechtlich sensible Tickets bleiben immer ausgeblendet. Es wird keine E-Mail verschickt; einzelne Einsätze lassen sich im Ticket wieder ausblenden.
      </span>
      {toast && <ToastPill text={toast.text} fehler={toast.fehler} />}
    </InnenKarte>
  );
}
